<template>
  <manual-page
    title="Reportes"
    description="Consulta reportes de ventas, ordenes y metricas de tu sucursal."
    :show-video="true"
    :related-links="relatedLinks"
    :action-route="{ name: 'biweekly' }"
    action-text="Ir a Reportes"
  >
    <h2>Reportes Disponibles</h2>

    <h3>Reporte Bisemanal</h3>
    <p>El reporte bisemanal incluye:</p>
    <ul>
      <li>Ventas totales de la quincena</li>
      <li>Numero de ordenes procesadas</li>
      <li>Clientes activos</li>
      <li>Productos mas vendidos</li>
      <li>Comparacion con quincena anterior</li>
    </ul>

    <div class="info-box">
      <p>Ideal para seguimiento operativo frecuente.</p>
    </div>

    <h3>Reporte Mensual</h3>
    <p>El reporte mensual incluye:</p>
    <ul>
      <li>Resumen financiero del mes</li>
      <li>Total de ingresos y egresos</li>
      <li>Ordenes por estado</li>
      <li>Nuevos clientes registrados</li>
      <li>Tendencias y proyecciones</li>
    </ul>

    <div class="info-box">
      <p>Util para analisis de rendimiento y planificacion.</p>
    </div>

    <h2>Seleccionar Periodo</h2>
    <p>Para seleccionar un periodo:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Accede a la seccion de Reportes
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Usa los selectores de fecha
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Elige el periodo que deseas analizar
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Los datos se actualizan automaticamente
    </div>

    <div class="tip-box">
      <p><strong>Tip:</strong> Puedes comparar cualquier periodo con otro anterior.</p>
    </div>

    <h2>Informacion en Reportes</h2>

    <h3>Metricas de Ventas</h3>
    <p>Metricas de ventas disponibles:</p>
    <ul>
      <li><strong>Ventas totales:</strong> Monto total facturado</li>
      <li><strong>Ticket promedio:</strong> Valor promedio por orden</li>
      <li><strong>Ordenes:</strong> Cantidad de pedidos</li>
      <li><strong>Clientes:</strong> Clientes unicos que compraron</li>
      <li><strong>Recurrencia:</strong> Porcentaje de clientes repetidos</li>
    </ul>

    <h3>Ordenes Procesadas</h3>
    <p>Metricas de ordenes:</p>
    <ul>
      <li><strong>Total procesadas:</strong> Ordenes completadas</li>
      <li><strong>Por estado:</strong> Desglose por cada estado</li>
      <li><strong>Tiempo promedio:</strong> De pago a entrega</li>
      <li><strong>Tasa de exito:</strong> Ordenes sin problemas</li>
    </ul>

    <div class="tip-box">
      <p><strong>Tip:</strong> Identifica cuellos de botella en la operacion.</p>
    </div>

    <h3>Comparativas</h3>
    <p>Las comparativas te ayudan a:</p>
    <ul>
      <li>Identificar tendencias de crecimiento o descenso</li>
      <li>Detectar estacionalidad en las ventas</li>
      <li>Evaluar el impacto de cambios operativos</li>
      <li>Establecer metas basadas en datos historicos</li>
    </ul>

    <div class="info-box">
      <p>Compara mes a mes o anio a anio para insights valiosos.</p>
    </div>
  </manual-page>
</template>

<script>
import ManualPage from "@/components/manual/ManualPage.vue";

export default {
  name: "ManualReports",
  components: { ManualPage },
  data() {
    return {
      relatedLinks: [
        { route: "manualAccounting", label: "Contabilidad" },
        { route: "manualOrders", label: "Ordenes" },
        { route: "manualGettingStarted", label: "Primeros Pasos" },
      ],
    };
  },
};
</script>
